(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-cart-quote"]) return;
  try {
    
function setupFieldhouseQuote() {
  const form = document.getElementById('FieldhouseQuote');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const detail = document.getElementById('FieldhouseQuoteDetails');
  if (form.querySelector('.fh-quote-success, .errors')) detail.open = true;
  const delivery = form.querySelector('[data-fh-delivery]');
  const address = form.querySelector('[data-fh-address]');
  const addressLabel = form.querySelector('[data-fh-address-label]');
  const updateDelivery = () => { address.required = delivery.value === 'Delivery'; addressLabel.hidden = !address.required; };
  delivery.addEventListener('change', updateDelivery);
  updateDelivery();
  const strings = JSON.parse(form.querySelector('[data-fh-quote-strings]').textContent);
  const button = form.querySelector('[data-fh-quote-submit]');
  const status = form.querySelector('[data-fh-quote-status]');
  let prepared = false;
  form.addEventListener('submit', async event => {
    if (prepared) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    button.disabled = true;
    status.textContent = strings.sending;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error(strings.error);
      const cart = await response.json();
      if (!cart.item_count) throw new Error(strings.empty);
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {style:'currency', currency:cart.currency}).format(cents / 100);
      const lines = cart.items.map(item => {
        const options = (item.options_with_values || []).filter(option => option.value !== 'Default Title').map(option => option.name + ': ' + option.value).join(', ');
        const properties = Object.entries(item.properties || {}).filter(([key]) => !key.startsWith('_')).map(([key,value]) => key + ': ' + value).join('; ');
        return item.quantity + ' × ' + item.product_title + (options ? ' — ' + options : '') + '\nSKU: ' + (item.sku || '—') + ' | Variant: ' + item.variant_id + ' | ' + money(item.final_line_price) + (properties ? '\n' + properties : '') + '\n' + new URL(item.url, location.origin).href;
      });
      form.querySelector('[data-fh-quote-body]').value = strings.subject + '\n\n' + lines.join('\n\n') + '\n\n' + strings.subtotal + ': ' + money(cart.total_price) + ' ' + cart.currency + (cart.note ? '\nCart note: ' + cart.note : '');
      prepared = true;
      button.disabled = false;
      status.textContent = '';
      form.requestSubmit(button);
    } catch (error) {
      prepared = false;
      button.disabled = false;
      status.textContent = error.message || strings.error;
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
    if (typeof event.cartData?.item_count === 'number') {
      document.querySelector('[data-fh-quote-wrapper]').hidden = event.cartData.item_count === 0;
      const emptyPrompt = document.querySelector('[data-fh-quote-empty]');
      if (emptyPrompt) emptyPrompt.hidden = event.cartData.item_count > 0;
    }
  });
}
setupFieldhouseQuote();
document.addEventListener('shopify:section:load', setupFieldhouseQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.fh-category-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.fh-category-menu[open]').forEach(menu => {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
